<!-- =========================================================================================
    File Name: ChatContact.vue
    Description: Chat contact - single component for chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="chat__contact flex items-center px-2 pt-4 pb-2">
        <div class="contact__avatar mr-1">
            <vs-avatar class="border-2 border-solid" :class="contact.is_online ? 'border-success' : 'border-danger'" :src="contact.custom_json.avatarUrl" size="42px" />
        </div>
        <div class="contact__container w-full flex items-center justify-between overflow-hidden">
            <div class="contact__info flex flex-col truncate w-5/6">
                <h5 class="font-semibold">{{ contact.last_name + ' ' + contact.first_name }}</h5>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contact: {type: Object, required: true,},
    },
}
</script>
